import { AbstractIdbaModel } from 'src/app/shared/models/abstract-idba-model';
 
export class CadastroGenerico extends AbstractIdbaModel {

  public override convertToModel(data: any): AbstractIdbaModel {
    return new CadastroGenerico(data);
  }
  public display(self: any): string {
    return self && self.codigo!=null && self.codigo!=undefined ? `${self.codigo} - ${self.descricao}` : '';
  }

  public displayCodigo(self: any): string {
    throw new Error("Method not implemented.");
  }

  public displayNome(self: any): string {
    throw new Error("Method not implemented.");
  }

  public filter(value: string, objectList: any[]): any[] {
    const filterValue = value.toLowerCase();
    return objectList.filter(
      (item) =>
        item.descricao.trim().toLowerCase().includes(filterValue) ||
        item.codigo.toString().toLowerCase().includes(filterValue)
    );
  }

  codigoCadGenerico: number;
  codigoLocal: number;
  assunto: string;
  codigo: number;
  descricao: string;
  codigoModulo: number;
  abrevModulo: string;
  sequencia: number;

  valores: CadastroGenerico[];
}
